import React from "react";
import ActivateAccountSupplier from "../../components/activateAccount/ActivateAccountSupplier";

const ActivateAccountSupplierPage = () => {
	return (
		<>
			<ActivateAccountSupplier />
		</>
	);
};

export default ActivateAccountSupplierPage;
